const s = {
  name: "Users2",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M27,0c-3.3,0-6,2.7-6,6c0,3.3,2.7,6,6,6s6-2.7,6-6C33,2.7,30.3,0,27,0z M23,6c0-2.2,1.8-4,4-4
			c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4C24.8,10,23,8.2,23,6z"/>
		<path class="st0" d="M13,9c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S16.3,9,13,9z M9,15c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4s-1.8,4-4,4
			C10.8,19,9,17.2,9,15z"/>
		<path class="st0" d="M7,25c-2.8,0-5,2.2-5,5v10H0V30c0-3.9,3.1-7,7-7h12c3.9,0,7,3.1,7,7v10h-2V30c0-2.8-2.2-5-5-5H7z"/>
		<path class="st0" d="M27,16h6c2.8,0,5,2.2,5,5v10h2V21c0-3.9-3.1-7-7-7h-6V16z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Users2
};
